module.exports = __webpack_public_path__ + "media/images/LifeShiftCommunity-416fdabeea97c1d071f2903f430e3ab1.png";